import type { DataResult } from '@shared/http/client';
import { apiFetch } from '@shared/http/client';

// 1:1 port of customer-apps/accounting (invoice.ts + accounting.service.ts).
export const BADGE_KEY_INVOICE = 'invoice';

export interface Invoice {
    id?: string
    number: string
    pdfExists: boolean
    pdfDownloadApiUrl: string
    createdAt?: string
    gross?: number
    reverseInvoice?: Invoice
    isReverseInvoice?: boolean
    isTaxCertificate?: boolean
    dunning?: Invoice[]
    dunningLevel?: number
    canceled?: boolean
    downloadedByMember?: boolean
}

type Params = Record<string, string | number | boolean>;

function toQuery(params?: Params): string {
    if (!params) {
        return '';
    }
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        search.set(key, String(value));
    }
    const serialized = search.toString();
    return serialized ? `?${serialized}` : '';
}

export async function getInvoices(params?: Params): Promise<Invoice[]> {
    const result = await apiFetch<DataResult<Invoice[]>>(`/invoices${toQuery(params)}`);
    return result.data;
}

export async function getCertificates(params?: Params): Promise<Invoice[]> {
    const result = await apiFetch<DataResult<Invoice[]>>(`/certificates${toQuery(params)}`);
    return result.data;
}

// Recursively counts receipts not yet downloaded by the member (incl. their dunning entries).
export function countUnread(receipts: Invoice[]): number {
    return receipts.reduce((unreadCount: number, invoice: Invoice) => {
        if (!invoice.downloadedByMember) {
            unreadCount++;
        }
        if (invoice.dunning && invoice.dunning.length > 0) {
            unreadCount += countUnread(invoice.dunning);
        }
        return unreadCount;
    }, 0);
}
